
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investment-calculator",
      function () {
        return require("private-next-pages/investment-calculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investment-calculator"])
      });
    }
  